import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, unref, nextTick } from 'vue';
import { ElMessage } from 'element-plus';

/* Componets */
import { GbDialog } from '@/components/GbDialog/Index';
import { CtTemplateForm } from '../forms/Index';

/* Apis */
import { GetCtTemplateInfoApi, EditTemplateApi, CreateTemplateApi } from '../../../../apis/ct_templates/templates.api';

/* Hooks */
import { useCtTempForm } from '../hooks/useCtTempForm';


export default /*#__PURE__*/_defineComponent({
  emits: ['onSuccess'],
  setup(__props, { expose, emit: $emits }) {

const { register, methods, elFormRef } = useCtTempForm();



const isEditor = ref<boolean>(false);
const showDialog = ref<boolean>(false);

/* 读取模板明细 */
const getTemplateInfo = (rowId: string) => {
	methods.setLoading(true);
	GetCtTemplateInfoApi(rowId)
		.then((res) => {
			if (!res.succeeded) {
				ElMessage.warning(`读取数据失败，可能的原因是：${res.errors}`);
			} else {
				methods.setFormData(res.data);
			}
		})
		.finally(() => {
			methods.setLoading(false);
		});
};

/* 读写组件内部函数 */
const writerMethods = {
	showDialog: () => {
		showDialog.value = true;

		nextTick(() => {
			isEditor.value = false;
		});
	},

	closeDialog: () => {
		showDialog.value = false;
	},

	/* 设置表单数据 */
	setCatetoryData: (rowId: string) => {
		getTemplateInfo(rowId);

		nextTick(() => {
			isEditor.value = true;

			showDialog.value = true;
		});
	},
};

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	unref(elFormRef)?.validate(async (isvalid: boolean) => {
		if (!isvalid) return;

		methods.setLoading(true);

		const data = methods.getFormData();
		const result = await (isEditor.value ? EditTemplateApi(data) : CreateTemplateApi(data));

		methods.setLoading(false);

		if (!result.succeeded) {
			ElMessage.warning(`保存失败，可能的原因是：${result.errors}`);
		} else {
			ElMessage.success(`保存成功`);
			$emits('onSuccess', {});
			showDialog.value = false;
		}
	});
};

expose({ writerMethods });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
    title: isEditor.value ? '编辑模板' : '创建模板',
    style: {"width":"600px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(methods).getLoadStatus(),
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(CtTemplateForm), { onRegister: _unref(register) }, null, 8, ["onRegister"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})